import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ number, label, title, sub, align = "left" }) => (
  <div className={align === "center" ? "text-center" : "text-left"}>
    <Reveal>
      <span className={`eyebrow ${align === "center" ? "justify-center" : ""}`}>
        {number && <span className="text-[#0050e0]/60">{number}</span>}
        {label}
      </span>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`h-display mt-4 max-w-2xl text-3xl leading-[1.08] sm:text-4xl lg:text-5xl ${align === "center" ? "mx-auto" : ""}`}>
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`mt-5 max-w-xl text-base leading-relaxed text-[#575a61] sm:text-lg ${align === "center" ? "mx-auto" : ""}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);
